import moment from 'moment';
import * as XLSX from 'xlsx';
import Box from '@mui/material/Box';
import { PdfTable } from './PdfTable';
import Loader from 'components/Loader';
import { DownloadOutlined } from '@ant-design/icons';
import ExitButton from 'components/button/ExitButton';
import { Fragment, useEffect, useState } from 'react';
import { useGetIdentityDataHistoryMutation } from 'store/features/process/processApi';
import { Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Stack, Typography } from '@mui/material';

const ListItem = ({ ismodify, index, title, value }) => {
	return (
		<Grid item xs={12}>
			<Grid container>
				<Grid item xs={3}>
					<Typography variant="subtitle3" color="initial">
						{title}
					</Typography>
				</Grid>

				<Grid item xs={1}>
					:
				</Grid>

				<Grid item xs={8}>
					<Typography
						variant="caption"
						color="initial"
						sx={{ color: index > 0 ? (ismodify ? 'inherit' : 'rgb(0, 0, 255) !important') : 'inherit' }}
					>
						{value}
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
};

const IdentityCaseActivityModal = ({ setSelectHistory, selectItem, processCode, processVersion, title }) => {
	const [allLabel, setAllLabel] = useState({});
	const [viewType, setViewType] = useState('page');
	const [allHistory, setAllHistory] = useState(null);

	const [GetIdentityDataHistory, { data, isSuccess, isLoading, isUninitialized }] = useGetIdentityDataHistoryMutation();

	const handleDownloadXlsl = (dataList = [], headers = []) => {
		const headerArray = ['Version', 'Date', ...Object.values(headers), 'Current User', 'Status'];
		const headerKeys = ['Version', 'Date', ...Object.keys(headers), 'activationStatus'];

		const valueArray = [];

		dataList?.forEach((item, index) => {
			const newArray = new Array(headerKeys.length).fill('-');

			newArray[0] = index + 1;
			newArray[1] = moment(item?.dateTime?.localDateTimeString)?.format('DD MMMM YYYY hh:mm A');

			Object.keys(item?.data).forEach((key) => {
				if (headerKeys?.includes(key)) {
					const index = headerKeys.indexOf(key);

					if (moment(item?.data?.[key], moment.ISO_8601, true).isValid()) {
						newArray[index] = moment(item?.data?.[key])?.format('YYYY-MM-DD');
					} else {
						newArray[index] = item?.data?.[key] ?? '-';
					}
				}
			});

			// newArray[headerArray?.length - 2] = item?.parkAction ? item.parkAction : 'Null';
			newArray[headerArray?.length - 2] = item?.approverUserId ? item?.approverUserId?.toString() : '-';
			newArray[headerArray?.length - 1] = item?.activationStatus ? item?.activationStatus : 'Null';

			valueArray[index] = newArray;
		});

		const wb = XLSX.utils.book_new();
		const ws = XLSX.utils.json_to_sheet([]);

		XLSX.utils.sheet_add_aoa(ws, [headerArray]);
		XLSX.utils.sheet_add_json(ws, valueArray, { origin: 'A2', skipHeader: true });
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, `${title?.toLowerCase()?.replace(' ', '_')}.xlsx`);
	};

	console.log('selectItem', selectItem, processCode, processVersion);

	useEffect(() => {
		if (selectItem?.id && processCode && processVersion) {
			GetIdentityDataHistory({
				processCode,
				processVersion,
				id: selectItem?.id,
			});
		}
	}, [selectItem, processCode, processVersion]);

	useEffect(() => {
		if (isSuccess) {
			setAllLabel(data?.result?.fieldLabelMap ?? []);

			const firstVersion = {
				data: {},
				dateTime: selectItem?.dateTime,
				parkAction: selectItem?.parkAction,
				approverUserId: selectItem?.approverUserId,
				parkSolutionTaskCode: '',
				activationStatus: selectItem?.activationStatus,
			};

			data?.result?.fieldLabelMap &&
				Object.keys(data?.result?.fieldLabelMap)?.forEach((item) => {
					firstVersion.data[item] = selectItem?.[item];
				});

			setAllHistory(
				data?.result?.allHistory
					? [
							// { ...(data?.result?.allHistory?.[0] ?? {}) },
							// ...(data.result.allHistory?.filter((item) => item?.recordStatus === 'saved') ?? []),
							...(data?.result?.allHistory?.filter((item, index) => index !== 0) ?? []),
							firstVersion,
						]
					: []
			);
		}
	}, [isSuccess]);

	return (
		<Dialog
			keepMounted
			maxWidth={'md'}
			fullWidth={true}
			aria-labelledby="pdf-dialog"
			open={selectItem === null ? false : true}
			sx={{
				'.MuiPaper-root': {
					borderRadius: '12px',
					border: '1px solid #E2E8F0',
					boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
					overflow: 'hidden',
				},
			}}
			onClose={() => {
				setSelectHistory(null);
			}}
		>
			<Box>
				<Box
					sx={{
						height: '46px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: '#F8FAFC',
						borderTopLeftRadius: '12px',
						borderTopRightRadius: '12px',
						borderBottom: '1px solid #E2E8F0',
					}}
				>
					<DialogTitle
						sx={{
							py: 0,
							px: 2,
							gap: 1,
							display: 'flex',
							height: '46px',
							fontSize: '16px',
							alignItems: 'center',
							color: '#0F172A',
							fontWeight: 600,
						}}
					>
						Change Log - {title}
					</DialogTitle>

					<Box sx={{ pr: 2, display: 'flex', alignItems: 'center', gap: '20px' }}>
						<Stack
							direction="row"
							alignItems="center"
							spacing={1}
							onClick={() => handleDownloadXlsl(allHistory, allLabel)}
							sx={{ color: '#475569', cursor: 'pointer', '&:hover': { color: '#0F172A' } }}
						>
							<DownloadOutlined style={{ fontSize: '18px' }} />
							<Typography variant="subtitle2">Download</Typography>
						</Stack>

						<ExitButton handleClose={() => setSelectHistory(null)} color="#64748B" />
					</Box>
				</Box>

				<Box sx={{ display: 'flex', gap: '8px', marginTop: '10px', marginLeft: '20px' }}>
					<Button
						type="button"
						onClick={() => setViewType('table')}
						sx={{
							color: '#fff',
							lineHeight: '20px',
							background: viewType === 'table' ? '#00914F' : '#868e9d',

							'&:hover': { background: viewType === 'table' ? '#00914F' : '#214689' },
						}}
					>
						Table View
					</Button>

					<Button
						type="button"
						onClick={() => setViewType('page')}
						sx={{
							color: '#fff',
							lineHeight: '20px',
							background: viewType === 'page' ? '#00914F' : '#868e9d',

							'&:hover': { background: viewType === 'table' ? '#214689' : '#00914F' },
						}}
					>
						PDF View
					</Button>
				</Box>
			</Box>

			<DialogContent sx={{ pb: 0, pt: 1.5, px: 3, backgroundColor: '#FFFFFF' }}>
				<Box sx={{ width: '100%', minHeight: 'calc(100svh - 230px)' }}>
					{(isUninitialized || isLoading) && <Loader />}

					{allHistory?.length > 0 &&
						!isLoading &&
						(viewType === 'table' ? (
							<PdfTable
								header={['Version', 'Date', ...Object.values(allLabel), 'Current User', 'Status']}
								headerKeys={[...Object.keys(allLabel)]}
								history={allHistory}
							/>
						) : (
							allHistory?.map((item, index) => (
								<Fragment key={index}>
									<Grid container spacing={1} sx={{ mt: 1.5 }}>
										<ListItem title="Version" value={index + 1} />
										{item?.dateTime?.localDateTimeString && (
											<ListItem
												title="Date"
												value={moment(item?.dateTime?.localDateTimeString)?.format('DD MMMM YYYY hh:mm A')}
											/>
										)}

										{Object.keys(allLabel).map((key) => {
											const value = item?.data?.[key];

											if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
												return null;
											}

											if (Array.isArray(value)) {
												return null;
											}

											if (moment(value, moment.ISO_8601, true).isValid() && key) {
												return (
													<ListItem
														key={key}
														title={allLabel?.[key]}
														value={moment(value)?.format('YYYY-MM-DD')}
														ismodify={allHistory?.[index - 1]?.data?.[key] === value}
														index={index}
													/>
												);
											}

											if (key) {
												return (
													<ListItem
														key={key}
														title={allLabel?.[key]}
														value={value}
														ismodify={allHistory?.[index - 1]?.data?.[key] === value}
														index={index}
													/>
												);
											}
											return null;
										})}

										{/* <ListItem
											index={2}
											title="Park Action"
											value={item?.parkAction ? item?.parkAction : 'Null'}
											ismodify={allHistory?.[index - 1]?.parkAction === item?.parkAction}
										/> */}

										{/* {item?.approverUserId && ( */}
										<ListItem
											index={index}
											title="Current User"
											value={item?.approverUserId?.toString() ?? '-'}
											ismodify={allHistory?.[index - 1]?.data?.approverUserId?.toString() === item?.approverUserId?.toString()}
										/>
										{/* )} */}

										{/* {item?.parkSolutionTaskCode && (
											<ListItem
												index={2}
												title="Park Solution Task"
												value={item?.parkSolutionTaskCode}
												ismodify={allHistory?.[index - 1]?.data?.parkSolutionTaskCode === item?.parkSolutionTaskCode}
											/>
										)} */}

										<ListItem
											index={index}
											title="Status"
											value={item?.activationStatus}
											ismodify={allHistory?.[index - 1]?.activationStatus === item?.activationStatus}
										/>
									</Grid>

									{index !== allHistory?.length - 1 && (
										<Divider sx={{ mt: 1, mb: 1, color: '#000 !important', bgcolor: '#000 !important', height: '1px' }} />
									)}
								</Fragment>
							))
						))}

					{allHistory?.length === 0 && !isLoading && (
						<Typography sx={{ color: 'gray', textAlign: 'center', fontSize: '16px', bold: '400', marginTop: '50px' }}>
							No change history found.
						</Typography>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default IdentityCaseActivityModal;
